// extracted by mini-css-extract-plugin
export default {"root":"_1MGB8","large":"_2WAgA","medium":"_2XcLX","small":"kgF7Y","daily-deviation":"_2P6XP","dailyDeviation":"_2P6XP","hype":"_1PO5K","stash":"_3QLK3"};